const masterSections =
  [
    {
      page: 'suppliedMastersPage',
      id: 'btn_db_expediente',
      code: 'suppliedMasters',
      group: 'other',
      title: 'MASTERS.SUPPLIED'
    },
    {
      page: 'presentsMastersPage',
      id: 'btn_masters',
      code: 'presentsMasters',
      group: 'other',
      title: 'MASTERS.PRESENTS'
    },
    {
      page: 'extraSaleMastersPage',
      id: 'btn_masters',
      code: 'extraSaleMasters',
      group: 'other',
      title: 'MASTERS.EXTRA_SALE'
    },
    {
      page: 'entityMastersPage',
      id: 'btn_masters',
      code: 'entityMasters',
      group: 'entities',
      title: 'MASTERS.ENTITY'
    },
    {
      page: 'processingAgency',
      id: 'btn_masters',
      code: 'processingAgency',
      group: 'paperworks',
      title: 'MASTERS.PROCESSING_AGENCY'
    },
    {
      page: 'financingMasters',
      id: 'btn_masters',
      code: 'financingMasters',
      group: 'other',
      title: 'MASTERS.FINANCING'
    },
    {
      page: 'associatedCostsMastersPage',
      id: 'btn_masters',
      code: 'associatedCostsMasters',
      group: 'other',
      title: 'MASTERS.ASSOCIATED_COSTS'
    },
    {
      page: 'fuelPage',
      id: 'btn_masters',
      code: 'fuel',
      group: 'vehicles',
      title: 'MASTERS.FUEL_TYPE'
    },
    {
      page: 'paymentMethod',
      id: 'btn_masters',
      code: 'paymentMethod',
      group: 'other',
      title: 'MASTERS.PAYMENT_METHOD'
    },
    {
      page: 'faqMastersPage',
      id: 'btn_masters',
      code: 'faqMasters',
      group: 'other',
      title: 'MASTERS.FAQ_MASTER_TITLE'
    },
    {
      page: 'faqSectionMastersPage',
      id: 'btn_masters',
      code: 'faqSectionMasters',
      group: 'other',
      title: 'MASTERS.FAQSECTIONS'
    },
    {
      page: 'processingAgencyAssignationPage',
      id: 'btn_masters',
      code: 'processingAgencyAssignation',
      group: 'paperworks',
      title: 'MASTERS.QUOTA_BY_PROCESSING'
    },
    {
      page: 'purchasePresentTypeMastersPage',
      id: 'btn_masters',
      code: 'purchasePresentTypeMasters',
      group: 'dossiers',
      title: 'MASTERS.PURCHASE_PRESENT_TYPE'
    },
    {
      page: 'campaignMasterPage',
      id: 'btn_masters',
      code: 'campaignMaster',
      group: 'campaigns',
      title: 'MASTERS.CAMPAIGN'
    },
    {
      page: 'campaignGroupMasterPage',
      id: 'btn_masters',
      code: 'campaignGroupMaster',
      group: 'campaigns',
      title: 'MASTERS.CAMPAIGN_GROUP'
    },
    {
      page: 'campaignTypeMasterPage',
      id: 'btn_masters',
      code: 'campaignTypeMaster',
      group: 'campaigns',
      title: 'MASTERS.CAMPAIGN_TYPE'
    },
    {
      page: 'styleTasksMasterPage',
      id: 'btn_masters',
      code: 'styleTasksMaster',
      group: 'dossiers',
      title: 'MASTERS.STYLE_TASK'
    },
    {
      page: 'financingTypeProductPage',
      id: 'btn_masters',
      code: 'financingTypeProduct',
      group: 'dossiers',
      title: 'MASTERS.FINANCING_TYPE_PRODUCTS'
    },
    {
      page: 'organizedUnitMasterUploadPage',
      id: 'btn_masters',
      code: 'organizedUnitMasterUpload',
      group: 'organizedUnits',
      title: 'MASTERS.OU'
    },
    {
      page: 'documentVisualizationMasterPage',
      id: 'btn_masters',
      code: 'documentVisualizationMaster',
      group: 'documents',
      title: 'MASTERS.DOCUMENT_VISUALIZATION.DOCUMENT_VISUALIZATION'
    },
    {
      page: 'documentTypeUseMasterPage',
      id: 'btn_masters',
      code: 'documentTypeUseMaster',
      group: 'documents',
      title: 'MASTERS.DOCUMENT_USE_TYPE'
    },
    {
      page: 'organizedUnitSaleOperationMasterPage',
      id: 'btn_masters',
      code: 'organizedUnitSaleOperationMaster',
      group: 'organizedUnits',
      title: 'MASTERS.OPERATION_TYPES_IN_SALE_TYPES'
    },
    {
      page: 'documentTypeMasterPage',
      id: 'btn_masters',
      code: 'documentTypeMaster',
      group: 'documents',
      title: 'MASTERS.DOCUMENT_TYPE'
    },
    {
      page: 'documentTypeMetadataMasterPage',
      id: 'btn_masters',
      code: 'documentTypeMetadataMaster',
      group: 'documents',
      title: 'MASTERS.DOCUMENT_TYPE_METADATA'
    },
    {
      page: 'operationTypeMasterPage',
      id: 'btn_masters',
      code: 'operationTypeMaster',
      group: 'dossiers',
      title: 'MASTERS.OPERATION_TYPE'
    },
    {
      page: 'directionUOMasterPage',
      id: 'btn_masters',
      code: 'directionUOMaster',
      group: 'organizedUnits',
      title: 'MASTERS.DIRECTIONS_OU'
    },
    {
      page: 'legalCompanyMasterPage',
      id: 'btn_masters',
      code: 'legalCompany',
      group: 'organizedUnits',
      title: 'MASTERS.LEGAL_COMPANY'
    },
    {
      page: 'organizedUnitConfigurationPage',
      id: 'btn_masters',
      code: 'organizedUnitConfigurationMaster',
      group: 'organizedUnits',
      title: 'MASTERS.ORGANIZED_UNIT_CONFIGURATION'
    },
    {
      page: 'pwkTypesMasterPage',
      id: 'btn_masters',
      code: 'pwkTypeMaster',
      group: 'paperworks',
      title: 'MASTERS.PWK_TYPES_MASTER.TITTLE'
    },
    {
      page: 'saleTypeMastersPage',
      id: 'btn_masters',
      code: 'saleTypeMasters',
      group: 'dossiers',
      title: 'MASTERS.SALE_TYPES'
    },
    {
      page: 'signatureTypeMasterPage',
      id: 'btn_masters',
      code: 'signatureTypeMaster',
      group: 'dossiers',
      title: 'MASTERS.SIGNATURE_TYPES'
    },
    {
      page: 'signatureConfigurationMasterPage',
      id: 'btn_masters',
      code: 'signatureConfigurationMaster',
      group: 'documents',
      title: 'MASTERS.SIGNATURE_CONFIGURATION'
    },
    {
      page: 'dossierStageMasterPage',
      id: 'btn_masters',
      code: 'dossierStageMaster',
      group: 'dossiers',
      title: 'MASTERS.DOSSIER_STAGES'
    },
    {
      page: 'processingAgencyOrganizedUnitConfigMasterPage',
      id: 'btn_masters',
      code: 'processingAgencyOrganizedUnitConfigMaster',
      group: 'paperworks',
      title: 'MASTERS.PROCESSING_AGENCY_ORGANIZED_UNIT_CONFIG.PROCESSING_AGENCY_ORGANIZED_UNIT_CONFIG'
    },
    {
      page: 'importVehicleModelMasterPage',
      id: 'btn_masters',
      code: 'importVehicleModelMaster',
      group: 'vehicles',
      title: 'MASTERS.VEHICLE_MODELS.TITLE_TAB'
    },
    {
      page: 'ratingMasterPage',
      id: 'btn_masters',
      code: 'ratingMaster',
      group: 'services',
      title: 'MASTERS.RATING'
    },
    {
      page: 'repairshopMasterPage',
      id: 'btn_masters',
      code: 'repairshopMaster',
      group: 'services',
      title: 'MASTERS.REPAIR_SHOPS'
    },
    {
      page: 'maritalStatusMasterPage',
      id: 'btn_masters',
      code: 'maritalStatusMaster',
      group: 'entities',
      title: 'MASTERS.MARITAL_STATUS'
    },
    {
      page: 'customFieldsMasterPage',
      id: 'btn_masters',
      code: 'customFieldsMaster',
      group: 'dossiers',
      title: 'MASTERS.CUSTOM_FIELDS.TITLE'
    },
    {
      page: 'destinationCraneMasterPage',
      id: 'btn_masters',
      code: 'destinationCraneMaster',
      group: 'services',
      title: 'MASTERS.DESTINATION_CRANE_MASTER.TITTLE'
    },
    {
      page: 'processingManagerMasterPage',
      id: 'btn_masters',
      code: 'processingManagerMaster',
      group: 'paperworks',
      title: 'MASTERS.PROCESSING_MANAGER.TITLE'
    },
    {
      page: 'codeCommissionMasterPage',
      id: 'btn_masters',
      code: 'codeCommissionMaster',
      group: 'other',
      title: 'MASTERS.CODE_COMMISSION.TITLE'
    },
    {
      page: 'adminUsersPage',
      id: 'btn_masters',
      code: 'adminUsers',
      group: 'users',
      title: 'ADMIN.USERS_TITLE'
    },
    {
      page: 'adminRolesPage',
      id: 'btn_masters',
      code: 'adminRoles',
      group: 'users',
      title: 'ADMIN.ROLES'
    },
    {
      page: 'adminRecurrentEntitiesPage',
      id: 'btn_masters',
      code: 'adminRecurrentEntities',
      group: 'entities',
      title: 'ADMIN.RECURRENT_ENTITIES_TITLE'
    },
    {
      page: 'templatesPage',
      id: 'btn_templates',
      code: 'templates',
      group: 'documents',
      title: 'SECTIONS.TEMPLATES'
    },
    {
      page: 'conditionsMaintenancePage',
      id: 'btn_conditions_maintenance',
      code: 'conditions-maintenance',
      group: 'dossiers',
      title: 'SECTIONS.CONDITIONS_MAINTENANCE'
    }

  ]

export default masterSections
